import { DetailPageLayout } from '@app/DetailPageLayout';
import { useMemo } from 'react';
import { Column, ResponsivePaginatedTable, createTableColumn } from '@gcl/react-core';
import { createTableDefaultColumn } from '@common/tableColumn.services';
import { routes } from '@routes/routes.models';
import { useNavigate } from '@routes/routes.hooks';
import { ApiErrorDisplay } from '@core/ApiErrorDisplay';
import { useGetLoadingRemovalCertsChecklistsCountAsync } from './report.queries';

export const ReportChecklistStatistics = () => {
  const { navigate } = useNavigate();
  const {
    data: dataChecklistCount,
    isLoading: isLoadingChecklistCount,
    isRefetching: isRefetchingChecklistCount,
    error: errorChecklistCount,
  } = useGetLoadingRemovalCertsChecklistsCountAsync();

  const columnsByProjectNo = useMemo(() => {
    const projectNos = new Set(
      dataChecklistCount?.map((checklist) => checklist.projectNo).filter((p): p is string => !!p),
    );
    const cols: Column[] = [...projectNos].map((projectNo) => {
      return createTableColumn({
        accessor: projectNo,
        Header: projectNo,
        disableSortBy: true,
      } as Column);
    });
    return [
      createTableDefaultColumn<any>('actionMonth', 'Month', undefined, undefined, undefined, false, true),
      ...cols,
    ];
  }, [JSON.stringify(dataChecklistCount)]);

  const groupByProjectNo = useMemo(() => {
    const groupByMonth = new Set(
      dataChecklistCount?.map((checklist) => checklist.actionMonth).filter((p): p is string => !!p),
    );
    return [...groupByMonth].map((month) => {
      const projectsOfMonth = dataChecklistCount?.filter((c) => c.actionMonth === month);
      let map: { [key: string]: number | string } = { actionMonth: month };
      projectsOfMonth?.map((p) => {
        if (p.projectNo) map = { ...map, [p.projectNo]: p.checklistCount };
      });
      return map;
    });
  }, [JSON.stringify(dataChecklistCount)]);
  return (
    <DetailPageLayout
      isGlobalPage
      errorGetDetail={null}
      isDrawer={false}
      isRestricted={false}
      data={dataChecklistCount}
      isLoading={isLoadingChecklistCount}
      isRefetching={isRefetchingChecklistCount}
      title="T4 Checklist Usage"
      breadcrumb={[
        {
          text: 'Home',
          prefixIconName: 'House',
          onClick: () => {
            navigate(routes.home.path);
          },
        },
        {
          text: 'Reports',
          prefixIconName: 'Clipboard2Data',
          onClick: () => navigate(routes.report.main.path),
        },
        {
          text: 'T4 Checklist Usage',
          prefixIconName: 'Clipboard2Data',
          active: true,
        },
      ]}
      render={() => {
        return (
          <>
            <ApiErrorDisplay errors={[{ error: errorChecklistCount, genericError: 'Get checklist usage failed' }]} />
            <ResponsivePaginatedTable
              disablePagination
              allowSelectRow={false}
              columns={columnsByProjectNo}
              items={groupByProjectNo ?? []}
            />
          </>
        );
      }}
    />
  );
};
